export const PainPointCard = {
  flow: 'y', gap: 'Z', padding: 'B', round: 'Z', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E',
  PainEmoji: { text: (el, s) => s.emoji, fontSize: 'C' },
  PainTitle: { tag: 'h3', text: (el, s) => s.title, fontSize: 'A', fontWeight: '600', color: 'inkText' },
  PainDetail: { text: (el, s) => s.detail, fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.6' }
}
